module.exports = __webpack_public_path__ + "img/pbi3.a6cfb03d.png";